import { Flex, Center, Heading, VStack } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { Logo } from '../../components/shared-components/Logo'
import ProfileCreationForm from './components/ProfileCreationForm'
import { PrescriberCreation } from '../../types/prescriber'

const PrescriberProfileCreationPage = () => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    trigger,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {} as PrescriberCreation,
  })

  return (
    <VStack
      as="form"
      overflow="auto"
      p="24px"
      pb="9"
      minHeight="100%"
      spacing="12"
      onSubmit={handleSubmit(() => {})}
    >
      <Center>
        <Logo maxWidth={100} />
      </Center>
      <Flex shadow="2xl" borderRadius="md" p="12" gap="6" direction="column" align="center">
        <Heading as="h2" textAlign="center" size="lg">
          <ProfileCreationForm
            {...{
              register,
              getValues,
              setValue,
              setError,
              errors,
              trigger,
            }}
          />
        </Heading>
      </Flex>
    </VStack>
  )
}
export default PrescriberProfileCreationPage
